import { RouterParamType } from "@/model/navModel";
import React, { FC } from "react";
import { TableBox } from "./TableBox";


export const Files: FC<RouterParamType> = (detailsInfo) => {

    return (
        <TableBox {...detailsInfo} />
    )
}